import { contactsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ASSIGNED_USERS_ACTION_TYPE = createNamedActions('assignedUsers', {
  GET_ASSIGNED_TO_APPLICATION_USERS: 'GET_ASSIGNED_TO_APPLICATION_USERS',
  RESET_ASSIGNED_USERS_STATE: 'RESET_ASSIGNED_USERS_STATE',
});

export const getAssignedToApplicationUsers = catchAsyncActionError(
  ({ applicationId }) =>
    async dispatch => {
      const { data } = await contactsApi.getLoanSummaryContacts({
        applicationId,
        internalUsersOnly: true,
      });

      return dispatch({
        type: ASSIGNED_USERS_ACTION_TYPE.GET_ASSIGNED_TO_APPLICATION_USERS,
        payload: data,
      });
    },
);

export const resetAssignedToApplicationUsers = () => dispatch => {
  return dispatch({
    type: ASSIGNED_USERS_ACTION_TYPE.RESET_ASSIGNED_USERS_STATE,
  });
};
